import React from 'react';
import MainLayout from '../layouts/MainLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from '@inertiajs/react';

export default function AdminDashboard({ user, stats = {} }) {
  const { usersCount = 0, facilitiesCount = 0, pendingClaims = 0 } = stats;
  
  return (
    <MainLayout user={user}>
      <div className="py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Admin Dashboard</h1>
          
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3 mb-8">
            <Card>
              <CardHeader>
                <CardTitle>Users</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-3xl font-bold">{usersCount}</p>
                <Button variant="outline" className="mt-4" asChild>
                  <Link href="/admin/users">Manage Users</Link>
                </Button>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader>
                <CardTitle>Facilities</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-3xl font-bold">{facilitiesCount}</p>
                <Button variant="outline" className="mt-4" asChild>
                  <Link href="/admin/facilities">Manage Facilities</Link>
                </Button>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader>
                <CardTitle>Pending Claims</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-3xl font-bold">{pendingClaims}</p>
                <Button variant="outline" className="mt-4" asChild>
                  <Link href="/admin/facility_claims">Review Claims</Link>
                </Button>
              </CardContent>
            </Card>
          </div>
          
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <Card>
              <CardHeader>
                <CardTitle>Quick Actions</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-2">
                  <Button variant="outline" className="w-full justify-start" asChild>
                    <Link href="/admin/facilities/new">Add New Facility</Link>
                  </Button>
                  <Button variant="outline" className="w-full justify-start" asChild>
                    <Link href="/admin/import">Import Facilities</Link>
                  </Button>
                  <Button variant="outline" className="w-full justify-start" asChild>
                    <Link href="/admin/plans">Manage Subscription Plans</Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader>
                <CardTitle>System Status</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="flex justify-between">
                    <span>Database</span>
                    <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Healthy</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Storage</span>
                    <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Healthy</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Background Jobs</span>
                    <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Running</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
